export default __webpack_public_path__ + "static/app_screenshot_6-e1843141bafb40a7e36215d2e0bba16a.webp";